import { useState, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const languages = [
  { code: 'en', label: 'English' },
  { code: 'pl', label: 'Polski' },
  { code: 'es', label: 'Español' },
  { code: 'fr', label: 'Français' },
];

export default function LanguageSwitcher() {
  const { i18n } = useTranslation();
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    function handleClick(e: MouseEvent) {
      if (ref.current && !ref.current.contains(e.target as Node)) {
        setOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, []);

  const current = languages.find((l) => l.code === i18n.language) || languages[0];

  return (
    <div ref={ref} className="relative">
      <button
        onClick={() => setOpen((v) => !v)}
        className="flex items-center gap-1.5 text-sm text-stone-600 hover:text-emerald-700 whitespace-nowrap cursor-pointer font-medium"
        aria-haspopup="listbox"
        aria-expanded={open}
      >
        <i className="ri-global-line text-base w-4 h-4 flex items-center justify-center" />
        <span>{current.label}</span>
        <i className={`ri-arrow-down-s-line text-base transition-transform ${open ? 'rotate-180' : ''}`} />
      </button>
      {open && (
        <div className="absolute right-0 mt-2 w-40 rounded-lg border border-stone-200 bg-white py-1 z-50">
          {languages.map((l) => (
            <button
              key={l.code}
              onClick={() => {
                i18n.changeLanguage(l.code);
                setOpen(false);
              }}
              className={`flex w-full items-center justify-between px-4 py-2 text-sm text-left hover:bg-emerald-50 cursor-pointer whitespace-nowrap ${
                l.code === i18n.language ? 'text-emerald-700 font-semibold' : 'text-stone-700'
              }`}
            >
              <span>{l.label}</span>
              {l.code === i18n.language && (
                <i className="ri-check-line text-emerald-600 w-4 h-4 flex items-center justify-center" />
              )}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}